// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__23oFy","boxTitle":"Qualiphy_boxTitle__ehSee","box":"Qualiphy_box__21l65","toggleWrap":"Qualiphy_toggleWrap__yFtSI"};